var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"banner-01"}},[_c('article',{staticClass:"banner"},[_c('div',{staticClass:"banner-logo-webstars"})])])}]

export { render, staticRenderFns }